enum MediaType {
    VOD    = 'VOD',
    LINEAR = 'LINEAR',
    LIVE   = 'LIVE'
}

export default MediaType;